module.exports = __webpack_public_path__ + "img/about1.a1080865.png";